export default __webpack_public_path__ + "static/media/ellips-4.e1f26cdc.svg";